import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { motion } from 'framer-motion'
import type { FC } from 'react'
import type { IClusterData } from '../molecules/VenuesMap/types'

type MarkerSize = 'lg' | 'md' | 'sm'
type PlusSize = 'lg' | 'sm'

function getMarkerSize(count: number): MarkerSize {
	if (count >= 20) return 'lg'
	if (count >= 10) return 'md'
	return 'sm'
}

const markerSizeMap: Record<MarkerSize, string> = {
	// lg: "w-14 text-h5",
	// md: "w-12 text-h6 pb-px",
	// sm: "w-10 text-h6 pb-0.5",
	lg: 'w-14 h-14 p-2.5',
	md: 'w-12 h-12 p-2.5',
	sm: 'w-10 h-10 p-2',
}

const plusSizeMap: Record<PlusSize, string> = {
	lg: 'w-5',
	sm: 'w-4',
}

const Plus: FC<{ size: PlusSize }> = ({ size }) => {
	return (
		<div
			className={clsx(
				'absolute -top-1 -right-1 w-4 h-4 box-border bg-blue rounded-full flex items-center justify-center text-white text-[8px]',
				plusSizeMap[size],
			)}
		>
			<FontAwesomeIcon icon={['fas', 'plus']} aria-hidden="true" />
		</div>
	)
}

export type MapClusterProps = {
	data: IClusterData
}

const MapCluster: FC<MapClusterProps> = ({ data }) => {
	const count = data.point_count
	const size = getMarkerSize(count)
	const plusSize: PlusSize = size === 'lg' ? 'lg' : 'sm'

	return (
		<motion.div
			initial={{ scale: 0 }}
			animate={{ scale: 1 }}
			exit={{ scale: 0 }}
			className={clsx(
				'relative text-blue box-border rounded-full flex items-center justify-center bg-white border-blue border-[3px] cursor-pointer',
				markerSizeMap[size],
			)}
		>
			<span className="text-h4">{count}</span>
			<Plus size={plusSize} />
		</motion.div>
	)
}

export default MapCluster
